import Cookie from 'js-cookie';

export function authHeader() {
    // return authorization header with jwt token
    // Primeiro tenta ler do cookie
    let token = Cookie.get('_easyindustria_token');
    
    // Se não encontrar no cookie, tenta ler do localStorage como fallback
    if (!token) {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        token = user.token;
    }
    
    if (token) {
        return {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
    } else {
        return {};
    }
}